import React from 'react'
import './Logo.css'
import logo from './bluediamond.png'
import { Link } from 'react-router-dom';

const Logo = (props) => {
    
    const isDesktop = props.isDesktop;
    
    return (
        <div id="logoContainer">
           <Link to="/"><img className={isDesktop? "bdLogo" : "mobileLogo"} alt="Blue Diamond Company Logo" src={logo} /></Link>
        </div>
    )
}

export default Logo
